import { createBrowserRouter, Navigate } from 'react-router-dom'
import { RouteErrorBoundary } from '@/app/routes/route-error-boundary'

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <RouteErrorBoundary />,
    lazy: () => import('@/app/layouts/root-layout').then((m) => ({ Component: m.RootLayout })),
    children: [
      {
        index: true,
        lazy: () =>
          import('@/modules/auth/screens/login').then((m) => ({ Component: m.LoginScreen })),
      },
      {
        path: 'login',
        lazy: () =>
          import('@/modules/auth/screens/login').then((m) => ({ Component: m.LoginScreen })),
      },
      {
        path: 'dashboard',
        lazy: () =>
          import('@/app/routes/protected-route').then((m) => ({ Component: m.ProtectedRoute })),
        children: [
          {
            // Pathless layout route — wraps all /dashboard/* children with the sidebar layout
            lazy: () =>
              import('@/app/layouts/dashboard-layout').then((m) => ({
                Component: m.DashboardLayout,
              })),
            children: [
              {
                index: true,
                lazy: () =>
                  import('@/modules/dashboard/screens/overview').then((m) => ({
                    Component: m.DashboardOverviewScreen,
                  })),
              },
              {
                path: 'analytics',
                lazy: () =>
                  import('@/modules/dashboard/screens/analytics-overview').then((m) => ({
                    Component: m.DashboardAnalyticsOverviewScreen,
                  })),
              },
              {
                path: 'properties',
                lazy: () =>
                  import('@/modules/properties/screens/property-list').then((m) => ({
                    Component: m.PropertyListScreen,
                  })),
              },
              {
                path: 'properties/new',
                lazy: () =>
                  import('@/modules/properties/screens/property-form').then((m) => ({
                    Component: m.PropertyFormScreen,
                  })),
              },
              {
                path: 'properties/:id',
                lazy: () =>
                  import('@/modules/properties/screens/property-detail').then((m) => ({
                    Component: m.PropertyDetailScreen,
                  })),
              },
              {
                path: 'properties/:id/edit',
                lazy: () =>
                  import('@/modules/properties/screens/property-edit').then((m) => ({
                    Component: m.PropertyEditScreen,
                  })),
              },
              {
                path: 'properties/:id/analytics',
                lazy: () =>
                  import('@/modules/properties/screens/property-analytics').then((m) => ({
                    Component: m.PropertyAnalyticsScreen,
                  })),
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
])
